import {
  EmployeePaymentMethodDetailsDto,
  EmployeePaymentMethodState,
  EmployeePaymentMethodType,
} from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export type PaymentMethodDisplayInfo = {
  isPaymentDetailsShown: boolean;
  badgeText: string;
  badgeType: 'in-handling' | 'not-available' | null;
};

const NOT_AVAILABLE_INFO: PaymentMethodDisplayInfo = {
  isPaymentDetailsShown: false,
  badgeText: 'No payment method available for this enrollment at this point.',
  badgeType: 'not-available',
};

export const FALLBACK_PAYMENT_METHOD_DETAILS: EmployeePaymentMethodDetailsDto =
  {
    type: EmployeePaymentMethodType.ZORRO_PAY,
    state: EmployeePaymentMethodState.NOT_AVAILABLE,
  };

export function getPaymentMethodDisplayInfo(
  state: EmployeePaymentMethodState,
  hasCreditCard: boolean
): PaymentMethodDisplayInfo {
  const paymentMethodName = hasCreditCard ? 'card' : 'payment account';

  return $enum.mapValue(state).with({
    [EmployeePaymentMethodState.AVAILABLE]: {
      isPaymentDetailsShown: true,
      badgeText: '',
      badgeType: null,
    },
    [EmployeePaymentMethodState.IN_HANDLING_WITHOUT_DETAILS]: {
      isPaymentDetailsShown: false,
      badgeText: 'This payment method is being handled by Zorro.',
      badgeType: 'in-handling',
    },
    [EmployeePaymentMethodState.IN_HANDLING_WITH_DETAILS]: {
      isPaymentDetailsShown: true,
      badgeText: `This ${paymentMethodName} is being updated by Zorro due to recent changes in the enrollment details.`,
      badgeType: null,
    },
    [EmployeePaymentMethodState.NOT_AVAILABLE]: NOT_AVAILABLE_INFO,
    [EmployeePaymentMethodState.CAN_BE_GENERATED]: NOT_AVAILABLE_INFO,
  });
}
